import { SubscriptionPlanIntervalEnum } from 'common/enums/SubscriptionPlanIntervalEnum'
import React from 'react'
import { useTranslation } from 'react-i18next'

type SubscriptionPlanProps = {
  amountWithCurrency: string
  interval: SubscriptionPlanIntervalEnum
  intervalCount: number
} & (
  | {
      trialInterval: SubscriptionPlanIntervalEnum
      trialPeriod: number
    }
  | {
      trialInterval?: never
      trialPeriod?: never
    }
)

function SubscriptionPlan({
  amountWithCurrency,
  trialInterval,
  trialPeriod,
  interval,
  intervalCount,
}: SubscriptionPlanProps) {
  const { t } = useTranslation(['common', 'publisher'])

  let readableAmount = ''
  if (trialPeriod) {
    const interval = t(`price_plan.trial_period.${trialInterval}_icu`, {
      count: trialPeriod,
    })
    readableAmount = `${t(
      'components.offer_price.price_plans.trial_period_new_icu',
      {
        trialPeriodPrice: t(
          'components.offer_price.price_plans.trial_period_price',
        ),
        trialInterval: interval,
      },
    )} `
  }
  // const readableAmountNew = readableAmount + t('components.offer_price.price_plans.unlimited_new_icu', {
  //   amount: amountWithCurrency,
  //   interval: t(`price_plan.interval.${interval}_icu`, {
  //     count: intervalCount,
  //   }),
  // })
  const readableAmountOld =
    readableAmount +
    t('components.offer_price.price_plans.unlimited_icu', {
      amount: amountWithCurrency,
      interval: t(`price_plan.interval.${interval}_icu`, {
        count: intervalCount,
      }),
      intervalHack: t(
        intervalCount > 1
          ? 'components.offer_price.price_plans.interval_hack_many'
          : 'components.offer_price.price_plans.interval_hack_one',
      ),
    })

  return <>{readableAmountOld}</>
}

export default SubscriptionPlan
